var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-standard"},[_c('div',{attrs:{"id":"map-container"}}),(_vm.loading && _vm.count == 0)?_c('div',{staticClass:"loader-overlay"},[_c('v-progress-circular',{staticClass:"circular-progress",attrs:{"size":"50","width":"5","indeterminate":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }